import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import StatisticsDashboard from './StatisticsDashboard';
import PhaseSection from './PhaseSection';
import ProviderCard from './ProviderCard';

function CalculationLogger({
  logMessages,
  providerLogs,
  liveStats,
  phaseStatuses,
  calculationProgress,
  calculationStep
}) {
  const phases = ['downloading', 'parsing', 'processing', 'calculating', 'saving'];

  return (
    <Box sx={{ mt: 4 }}>
      {/* Live Statistics Dashboard */}
      <StatisticsDashboard stats={liveStats} />

      {/* Phase Sections */}
      <Box sx={{ mb: 3 }}>
        {phases.map((phase) => (
          <PhaseSection
            key={phase}
            phase={phase}
            status={phaseStatuses[phase]}
            logs={logMessages[phase] || []}
            duration={phaseStatuses[phase] === 'completed' ? calculatePhaseDuration(phase, logMessages[phase]) : null}
          />
        ))}
      </Box>

      {/* Provider Breakdown - Show when calculating phase is active */}
      {(calculationStep === 'calculating' || calculationStep === 'saving' || calculationStep === 'completed') && 
       providerLogs && Object.keys(providerLogs).length > 0 && (
        <Box sx={{ mt: 3 }}>
          <Paper
            elevation={0}
            sx={{
              p: 2,
              bgcolor: 'grey.50',
              borderRadius: 2
            }}
          >
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
              Provider Breakdown
            </Typography>
            <Box sx={{ maxHeight: 400, overflowY: 'auto', mt: 2 }}>
              {Object.entries(providerLogs).map(([providerId, data]) => (
                <ProviderCard
                  key={providerId}
                  providerName={data.name}
                  data={data}
                />
              ))}
            </Box>
          </Paper>
        </Box>
      )}
    </Box>
  );
}

function calculatePhaseDuration(phase, logs) {
  if (!logs || logs.length === 0) return null;
  
  const firstLog = logs[0];
  const lastLog = logs[logs.length - 1];
  
  if (firstLog.timestamp && lastLog.timestamp) {
    return lastLog.timestamp - firstLog.timestamp;
  }
  
  return null;
}

export default CalculationLogger;

